import type { DependencyList } from "react";
import { useLayoutEffect, useRef, useState } from "react";

interface Options {
  /**
   * When `true`, overflow detection is skipped and the last detected value persists.
   */
  disabled?: boolean;
}

const useVerticalOverflowDetection = (deps: DependencyList, options?: Options) => {
  const { disabled } = options ?? {};

  const containerRef = useRef<HTMLElement>(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  useLayoutEffect(() => {
    const updateOverflow = () => {
      if (disabled || !containerRef.current) {
        return;
      }
      // eslint-disable-next-line @eslint-react/set-state-in-effect
      setHasOverflow(containerRef.current.scrollHeight > containerRef.current.offsetHeight);
    };

    updateOverflow();
    window.addEventListener("resize", updateOverflow);
    return () => window.removeEventListener("resize", updateOverflow);
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [disabled, ...deps]);

  return { hasOverflow, containerRef };
};

export default useVerticalOverflowDetection;
